import React, { useState } from 'react';
import DateInput from '../common/DateInput';
import FormDialog from '../common/FormDialog';
import { tachoApi } from '../../api/services';
import { useAlerts } from '../../custom/Alerts';
import { addDays } from '../../utils/dates';

/* Generiše aktivnosti "Odmor" od 24h za izabrani period (dani koji već imaju aktivnosti su isključeni). */
export default function AutoBreakDialog({ driver, date, busyDates, onClose, onDone }) {
    const alerts = useAlerts();
    const [start, setStart] = useState(date);
    const [end, setEnd] = useState(addDays(date, 1));

    const save = async () => {
        try {
            await tachoApi.autoGenerateBreak(driver.id, start, end);
        } catch {
            alerts.error('Dodavanje aktivnosti neuspešno');
            return;
        }
        alerts.success('Aktivnosti su uspešno dodate');
        /* ponovno učitavanje zauzetih datuma ima svoju grešku (interceptor), ne "Dodavanje neuspešno" */
        try { await onDone(); } catch { /* toast */ }
        onClose();
    };

    return (
        <FormDialog visible title="Generiši Odmor aktivnosti" onClose={onClose} onSave={save} saveLabel="Generiši" canSave={!!start && !!end} width="32rem">
            <p className="form-hint">Generiši aktivnosti tipa "Odmor" u trajanju od 24h za period:</p>
            <div className="form-grid cols-2">
                <div className="field"><label htmlFor="ab-from">Od</label>
                    <DateInput inputId="ab-from" value={start} onChange={(e) => setStart(e.value)} dateFormat="dd.mm.yy" disabledDates={busyDates} showIcon /></div>
                <div className="field"><label htmlFor="ab-to">Do</label>
                    <DateInput inputId="ab-to" value={end} onChange={(e) => setEnd(e.value)} dateFormat="dd.mm.yy" disabledDates={busyDates} showIcon /></div>
            </div>
            <p className="panel-note"><i className="pi pi-info-circle" aria-hidden="true" />Dani koji već imaju aktivnosti se preskaču.</p>
        </FormDialog>
    );
}
